export const getProjectedCostKey = (phase: string, costType: number) =>
  `${phase}|${costType}`;

export const getProjectedCostBase = (cost: {
  ProjCost?: number;
  CurrentEst?: number;
}) => cost.ProjCost || cost.CurrentEst || 0;
